import React from 'react';
import {AudioPlayer} from 'generic/AudioPlayer/AudioPlayer.react';
import constants from 'client/constants';
import {AuthoringSupplementModelV1} from 'resources/augmented/AuthoringSupplement/AuthoringSupplementModel.v1';
import {SupplementModelV1} from 'resources/augmented/Supplement/SupplementModel.v1';
import {
  NoTranslationWarningHeader,
  notAvailableText
} from 'client/components/QuestionTypes/shared/TranslationSection';

import './audio.scss';

interface Props {
  content?: any;
  supplement: AuthoringSupplementModelV1 | SupplementModelV1;
  noTranslation?: boolean;
  showTranslationInfo?: boolean;
  showTranslatedSupplements?: boolean;
}

export default function Audio({
  supplement,
  content: propsContent,
  noTranslation = false,
  showTranslationInfo = false,
  showTranslatedSupplements = false
}: Props) {
  const content = supplement.getContent();
  const audioFile = content.get('audio');

  if (!audioFile) {
    return null;
  }

  // Content is also passed down to Image V2 in the supplement renderer
  // Translated supplements pass translated caption to content
  // use old method of getting caption as fallback in case there are instances
  // where content isn't passed down
  const caption = propsContent?.toJS?.()?.caption || supplement.getCaption();

  const showWarning = (noTranslation || !showTranslatedSupplements) && showTranslationInfo;

  const Wrapper = showWarning ? NoTranslationWarningHeader : React.Fragment;

  return (
    <div className='audio-supplement-wrapper my-x1 w-full'>
      <Wrapper text={notAvailableText} supplement>
        <AudioPlayer caption={caption} src={`${constants.SUPPLEMENTS_ORIGIN}/${audioFile}`} />
      </Wrapper>
    </div>
  );
}
